import React from 'react';
const Play = ({ fill = 'currentColor', width = 20, height = 20 }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 3.5L16 10L5 16.5V3.5Z" fill={fill} />
  </svg>
);
export default Play;
